/**
 * API base URL. Use deployed backend or local.
 * Set REACT_APP_API_URL in .env.local to point at deployed backend, e.g.:
 *   REACT_APP_API_URL=https://almadrbak.vercel.app
 */
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';
